import { render, staticRenderFns } from "./couponSubCategory.vue?vue&type=template&id=063219ec&class=full-height"
import script from "./couponSubCategory.vue?vue&type=script&lang=js"
export * from "./couponSubCategory.vue?vue&type=script&lang=js"
import style0 from "./couponSubCategory.vue?vue&type=style&index=0&id=063219ec&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063219ec')) {
      api.createRecord('063219ec', component.options)
    } else {
      api.reload('063219ec', component.options)
    }
    module.hot.accept("./couponSubCategory.vue?vue&type=template&id=063219ec&class=full-height", function () {
      api.rerender('063219ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/coupon/couponCategory/couponSubCategory.vue"
export default component.exports